/* hottey One Pager – shared interactions. Idempotent (safe if included multiple times). */
(function () {
  if (window.__hottey_lp) return;
  window.__hottey_lp = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveal ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-hl-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Count up ---------- */
  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-hl-count]:not([data-done])');
    if (!els.length) return;
    function run(el) {
      el.setAttribute('data-done', '1');
      var target = parseFloat(el.getAttribute('data-hl-count')) || 0;
      if (reduce) { el.textContent = target.toLocaleString('de-DE'); return; }
      var start = null, dur = 1400;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased).toLocaleString('de-DE');
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'hl hl-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------- Add to cart (single + bundle) ---------- */
  function addToCart(btn) {
    var items;
    try { items = JSON.parse(btn.getAttribute('data-hl-add')); } catch (e) { return; }
    if (!items || !items.length) return;

    var qtyInput = btn.getAttribute('data-hl-qty') && document.getElementById(btn.getAttribute('data-hl-qty'));
    if (qtyInput && items.length === 1) items[0].quantity = Math.max(1, parseInt(qtyInput.value, 10) || 1);

    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    var root = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(root + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        if (!res.ok || res.data.status) {
          toast(res.data.description || res.data.message || 'Das hat leider nicht geklappt. Bitte versuch es nochmal.');
          return;
        }
        var label = btn.querySelector('[data-hl-label]');
        var old = label ? label.textContent : null;
        btn.classList.add('is-added');
        if (label) label.textContent = 'Im Warenkorb ✓';
        setTimeout(function () { btn.classList.remove('is-added'); if (label && old) label.textContent = old; }, 2200);

        if (drawer && res.data.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          try { drawer.renderContents(res.data); } catch (e) { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
        } else {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var bubble = document.querySelector('.cart-count-bubble span[aria-hidden]');
            if (bubble) bubble.textContent = cart.item_count;
          }).catch(function () {});
          toast('Im Warenkorb! 🍯');
          if (btn.hasAttribute('data-hl-goto-cart')) window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        document.dispatchEvent(new CustomEvent('hottey:added', { detail: { items: items } }));
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        toast('Verbindungsproblem. Bitte versuch es nochmal.');
      });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-hl-add]');
    if (add && !add.disabled) { e.preventDefault(); addToCart(add); return; }

    var q = e.target.closest('[data-hl-step]');
    if (q) {
      var input = q.parentElement.querySelector('input');
      var v = (parseInt(input.value, 10) || 1) + parseInt(q.getAttribute('data-hl-step'), 10);
      input.value = Math.min(99, Math.max(1, v));
      return;
    }

    var a = e.target.closest('a[href^="#"]');
    if (a && a.getAttribute('href').length > 1) {
      var target = document.getElementById(a.getAttribute('href').slice(1));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', a.getAttribute('href'));
      }
    }
  });

  /* ---------- Scrollers with arrows + progress ---------- */
  function initScrollers(root) {
    (root || document).querySelectorAll('[data-hl-scroller]:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '1');
      var track = wrap.querySelector('.hl-scroller');
      var bar = wrap.querySelector('.hl-progress span');
      var prev = wrap.querySelector('[data-hl-prev]');
      var next = wrap.querySelector('[data-hl-next]');
      if (!track) return;
      function step() { var c = track.children[0]; return c ? c.getBoundingClientRect().width + 18 : 300; }
      function update() {
        if (!bar) return;
        var max = track.scrollWidth - track.clientWidth;
        var ratio = track.clientWidth / track.scrollWidth;
        bar.style.width = Math.max(ratio * 100, 12) + '%';
        var p = max > 0 ? track.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + (p * (100 / Math.max(ratio, .12) - 100)) + '%)';
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initAll(root) { initReveal(root); initCounters(root); initScrollers(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  window.hotteyLP = { init: initAll, toast: toast };
})();
